import { BadgeFaceted } from './BadgeFaceted.component';

export { BadgeFaceted };
